import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import translationEN from '../public/locales/en/translation.json'
import translationDE from '../public/locales/ru/translation.json'

const languages = ['en', 'ru']

const resources = {
	en: {
		translation: translationEN,
	},
	ru: {
		translation: translationDE,
	},
}

i18n
	// Подключение бэкенда i18next
	.use(Backend)
	// Автоматическое определение языка
	// .use(LanguageDetector)
	// модуль инициализации
	.use(initReactI18next)
	.init({
		// fallbackLng: 'en', // use et if detected lng is not available
		saveMissing: true, // send not translated keys to endpoint
		debug: true,
		whitelist: languages,
		resources,
		detection: {
			order: ['localStorage', 'cookie'],
			caches: ['localStorage', 'cookie'],
		},
		interpolation: {
			escapeValue: false,
		},
		fallbackLng: 'en',
		seDataAttrOptions: true,
		// preload: ['en'],
		react: {
			useSuspense: false,
		},
	})

export default i18n
